import script from "./PatientClinicianExerciseModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientClinicianExerciseModal.vue?vue&type=script&setup=true&lang=js"

import "./PatientClinicianExerciseModal.vue?vue&type=style&index=0&id=065a4cc6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-065a4cc6"]])

export default __exports__